import { GenericServerError } from '~/types/GenericServerError';
import { schema, Schema } from './register-form.schema';
import { zodResolver } from '@hookform/resolvers/zod';
import { Button } from '~/components/Button/Button';
import { useRegisterMutation } from '../mutations';
import { Panel } from '~/components/Panel/Panel';
import { Grid } from '~/components/Grid/Grid';
import { Fragment } from 'react/jsx-runtime';
import { Input } from '~/components/Input';
import { useNavigate } from 'react-router';
import { useForm } from 'react-hook-form';
import { isAxiosError } from 'axios';
import { useState } from 'react';

export function RegisterForm() {
  const [error, setError] = useState<string>();

  const mutation = useRegisterMutation();
  const navigate = useNavigate();

  const { formState, handleSubmit, register } = useForm<Schema>({
    resolver: zodResolver(schema),
  });

  async function onSubmit(payload: Schema) {
    try {
      await mutation.mutateAsync({
        url: `${window.location.origin}/auth/sign-up/verify/`,
        ...payload,
      });
      navigate('/auth/sign-up/success');
    } catch (e) {
      if (isAxiosError(e) && e.status === 400) {
        setError((e.response?.data as GenericServerError).error);
      }
    }
  }

  return (
    <Fragment>
      {error && (
        <Panel variant="error" size="sm" style={{ marginBottom: 'var(--size-4)' }} rounded>
          {error}
        </Panel>
      )}

      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid style={{ rowGap: 0 }}>
          <Grid.Item cols={{ sm: 12, md: 6 }}>
            <Input.Group htmlFor="first_name" label="Förnamn" formState={formState}>
              <Input.Field type="text" {...register('first_name')} formState={formState} />
            </Input.Group>
          </Grid.Item>
          <Grid.Item cols={{ sm: 12, md: 6 }}>
            <Input.Group htmlFor="last_name" label="Efternamn" formState={formState}>
              <Input.Field type="text" {...register('last_name')} formState={formState} />
            </Input.Group>
          </Grid.Item>
        </Grid>

        <Input.Group htmlFor="email" label="E-post" formState={formState}>
          <Input.Field type="email" {...register('email')} formState={formState} />
        </Input.Group>

        <Input.Group htmlFor="username" label="Användarnamn" formState={formState}>
          <Input.Field type="text" {...register('username')} formState={formState} />
        </Input.Group>

        <Input.Group htmlFor="password1" label="Lösenord" formState={formState}>
          <Input.Field type="password" {...register('password1')} formState={formState} />
        </Input.Group>

        <Input.Group htmlFor="password2" label="Lösenord (igen)" formState={formState}>
          <Input.Field type="password" {...register('password2')} formState={formState} />
        </Input.Group>

        <Button.Group align="right">
          <Button type="submit" isLoading={mutation.isPending}>
            Skapa konto
          </Button>
        </Button.Group>
      </form>
    </Fragment>
  );
}
